(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCustomers', {
                parent: 'app',
                url: '/customers',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminCustomers/adminCustomers.html',
                        controller: 'AdminCustomersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    eventCycle: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.eventCycle();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    .state('adminCustomerView', {
            abstract: true,
            parent: 'app',
            url: '/customers/search?id:customerId:stateFrom',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                pageTitle: 'sigmaCrmApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminCustomers/adminCustomerView.html',
                    controller: 'AdminCustomerViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                healthVisitorEditSector: ['ApplicationParameters', function (ApplicationParameters) {
                    return ApplicationParameters.getParameter('Health_Visitor_Edit_Sector');
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
